import en from "./en.json";
import de from "./de.json";
import sv from "./sv.json";

function getLocalLanguage(): string {
  return navigator.language.substring(0, 2);
}

export const defaultLocale = getLocalLanguage() || "en";

export const languages: any = {
  en,
  de,
  sv
};
